// extracted by mini-css-extract-plugin
export default {"block":"block___f0Lv2","resourceName":"resourceName___U8HZW","btn":"btn___Sl5H6"};